
import { Breadcrumb as BreadcrumbModel } from '../../store/breadcrumb';
import { IDomain } from '@homeserve/od-typings/api';
import { Component, Watch, Prop, Mixins } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { IBreadcrumbDefault18n, IBreadcrumbOverride18n } from './types';
import { I18nMixin } from '../../mixins';

@Component
export default class Breadcrumb extends Mixins(I18nMixin) {
  get displayableDomain() {
    return this.domains.find(d => {
      return d.slug.toLowerCase() === this.domain;
    });
  }

  get formattedDomain() {
    return (input: string) =>
      input.toLowerCase().startsWith('é') ? `problème d'${input.toLowerCase()}` : `problème de ${input.toLowerCase()}`;
  }

  get formattedOurRatesDomain() {
    return (input: string) => `Tarifs dépannage ${input.toLowerCase()}`;
  }

  get otherDomains() {
    return this.domains.filter(d => d.slug !== this.domain);
  }

  public defaultI18n!: IBreadcrumbDefault18n;

  @Prop()
  public overrideI18n!: IBreadcrumbOverride18n;

  @State('breadcrumb', { namespace: 'app/breadcrumb' })
  private breadcrumb!: BreadcrumbModel[];

  private displayBreadcrumb = true;
  private displayOurRatesDomain = false;

  @State('domain', { namespace: 'app/breadcrumb' })
  private domain!: string;

  private domainDisplay = '';
  private ourRatesDomainDisplay = '';

  @State('domains', { namespace: 'api/catalog/domain' })
  private domains!: IDomain[];

  // hide the breadcrumb on the homepage
  private checkHomeRoute() {
    this.displayBreadcrumb =
      !!this.$route.name && ['login', 'home', 'home-conversion'].indexOf(this.$route.name) === -1;
  }

  // change displaying domain for our rates
  private checkOurRatesRoute() {
    this.displayOurRatesDomain =
      !!this.$route.name && ['ourRates', 'ourRatesByDomain'].indexOf(this.$route.name) !== -1;
  }

  created() {
    this.defaultI18n = {
      to_home: this.$t('components_plugin.breadcrumb.to_home'),
    };
  }

  mounted() {
    this.setDisplayableDomain();
    this.setDisplayableOurRatesDomain();
    this.checkHomeRoute();
    this.checkOurRatesRoute();
  }

  private setDisplayableDomain() {
    if (this.displayableDomain) {
      this.domainDisplay = this.formattedDomain(this.displayableDomain.name);
    } else {
      this.domainDisplay = '';
    }
  }

  private setDisplayableOurRatesDomain() {
    if (this.displayableDomain) {
      this.ourRatesDomainDisplay = this.formattedOurRatesDomain(this.displayableDomain.name);
    } else {
      this.ourRatesDomainDisplay = '';
    }
  }

  @Watch('domain')
  private watchDomain() {
    this.setDisplayableDomain();
    this.setDisplayableOurRatesDomain();
  }

  @Watch('$route')
  private watchRoute() {
    this.checkHomeRoute();
    this.checkOurRatesRoute();
  }
}
